<template>
  <div class="p-4 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 sm:p-6 dark:bg-gray-800">
    <div class="flex justify-between">
      <div class="flex-grow">
        <h3 class="text-base font-normal text-gray-500 dark:text-gray-400 capitalize">{{ title }}</h3>
        <span class="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">{{
            data?.title
          }}</span>
        <p class="flex items-center text-base font-normal text-gray-500 dark:text-gray-400">
            <span class="flex items-center mr-1.5 text-sm text-green-500 dark:text-orange-400">
              <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"
                   aria-hidden="true">
                <path clip-rule="evenodd" fill-rule="evenodd"
                      d="M10 17a.75.75 0 01-.75-.75V5.612L5.29 9.77a.75.75 0 01-1.08-1.04l5.25-5.5a.75.75 0 011.08 0l5.25 5.5a.75.75 0 11-1.08 1.04l-3.96-4.158V16.25A.75.75 0 0110 17z"></path>
              </svg>
              3,4%
            </span>
          Since last month
        </p>
      </div>
      <MonthsSelect @dateChange="onMonthChanged"/>
    </div>
    <div
        class="justify-between items-start  sm:flex ">
      <div class="w-full" id="chart_container"></div>
    </div>
  </div>

</template>
<script setup lang="ts">
import {onMounted, ref} from "vue";
import ApexCharts from "apexcharts";
import {isDarkMode, generateData} from '~/lib/tools';
import MonthsSelect from "./months-select.vue";
import {fetchMachineIncidents} from "~/lib/api/machines";

import {getDaysInMonth} from "date-fns";
import {useRoute} from "vue-router";

let route = useRoute();
const emit = defineEmits(["dateChange"])

const props = defineProps({
  title: {
    type: String,
    required: false,
    default: 'Events'
  },
});
let {title} = props;
let data = ref({title: null});

let currentDate = ref(new Date());

onMounted(() => {
  setStats();
})
const chart = ref(null as any | null);
const setStats = () => {
  updateStats();
  if (document.getElementById('chart_container')) {
    chart.value = new ApexCharts(document.getElementById('chart_container'), getSignupsChartOptions({
      values: [],
      labels: []
    }));
    chart.value.render();
    // init again when toggling dark mode
    document.addEventListener('dark-mode', function () {
      updateStats();
    });
  }
}
const fetchData = async () => {
  let beginningOfCurrentMonth = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth(), 1);
  let endOfCurrentMonth = new Date(currentDate.value.getFullYear(), currentDate.value.getMonth() + 1, 0);
  return fetchMachineIncidents(route.params.organization_uuid, route.params.machine_id, {
    status: null,
    from: beginningOfCurrentMonth,
    to: endOfCurrentMonth,
    'chart': 'day'
  });
}
const updateStats = async () => {
  var r = await fetchData();
  /*console.log('updownd: response', r.data);
  console.log('updownd: response', r.data);
  console.log('updownd: response', r.data);
  console.log('updownd: response', r.data);
  console.log('updownd: response', r.data);*/
  chart.value.updateOptions(getSignupsChartOptions(r.data));
}
const getSignupsChartOptions = ({labels, values}) => {
  let signupsChartColors = {}
  if (isDarkMode()) {
    signupsChartColors = {
      backgroundBarColors: ['#374151', '#374151', '#374151', '#374151', '#374151', '#374151', '#374151']
    };
  } else {
    signupsChartColors = {
      backgroundBarColors: ['#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB', '#E5E7EB']
    };
  }
  return {
    series: [{
      name: 'Incidents',
      data: values
    }],
    labels: labels,
    chart: {
      type: 'bar',
      height: '140px',
      foreColor: '#4B5563',
      fontFamily: 'Inter, sans-serif',
      toolbar: {
        show: false
      }
    },
    theme: {
      monochrome: {
        enabled: true,
        color: '#AA22FF',
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '25%',
        borderRadius: 3,
        colors: {
          backgroundBarColors: signupsChartColors.backgroundBarColors,
          backgroundBarRadius: 3
        },
      },
      dataLabels: {
        hideOverflowingLabels: false,
        enabled: true
      }
    },
    xaxis: {
      floating: false,
      tickAmount: 'dataPoints',
      labels: {
        show: true
      },
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
    },
    tooltip: {
      shared: true,
      intersect: false,
      style: {
        fontSize: '14px',
        fontFamily: 'Inter, sans-serif'
      }
    },
    states: {
      hover: {
        filter: {
          type: 'darken',
          value: 0.8
        }
      }
    },
    fill: {
      opacity: 1
    },
    yaxis: {
      show: false
    },
    grid: {
      show: false
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      show: false
    },
  };
}

const onMonthChanged = (month: Date) => {
  currentDate.value = new Date();
  currentDate.value.setDate(1);
  currentDate.value.setMonth(month.getMonth());
  console.log('updownd: currentDate', currentDate.value);
  updateStats();
}
</script>

<style scoped>

</style>